import React, { useEffect, useState } from 'react'
import { Select } from '@arnsbogroup/react-voicearchive'
import AccentsAndDialects from './components/AccentsAndDialects'

const Profile = ( {supplier, onChangeHandler, currentUser} ) => {
    const [priorityOptions, setPriorityOptions] = useState([])

    if (!supplier) {
        return null
    }

    useEffect(() => {
        fetch('/rest/v2/supplierpriority?pageSize=999&search[hidden]=0&search[deleted]=0')
            .then((response) => response.json())
            .then((priorities) => {
                setPriorityOptions(priorities.map((priority) => ({value: priority.uid, label: priority.name})))
            })
            .catch((err) => {
                toastr.error(err)
            })
    }, [])

    return (
        <div className='p-4'>
            <div className='w-1/2'>
                <div className='pr-3'>
                    <Select
                        label="Priorities"
                        description="Priorities that the supplier belongs to"
                        isMulti
                        placeholder="Priorities"
                        options={priorityOptions}
                        onChange={(priorities) => { 
                            onChangeHandler({ ...supplier, priorities: priorities ? priorities.map((priority) => ({uid: priority.value, name: priority.label})) : [] }) 
                        }} 
                        value={supplier.priorities.map((priority) => ({value: priority.uid, label: priority.name}))}
                    />
                </div>
            </div>
            <AccentsAndDialects supplier={supplier} onChangeHandler={onChangeHandler}/>
            {supplier?.studio_image &&
                <div className='w-1/2'>
                    <label className="text-gray-700 text-sm font-medium">Supplier studio setup</label>
                        <img
                            src={supplier?.studio_image}
                            alt="Studio setup Preview"
                            className='w-full h-auto cursor-pointer'
                            onClick={() => window.open(supplier?.studio_image, '_blank')}
                        />
                </div>
            }
        </div>
    )
}

export default Profile
